import Constants from 'constants';
import { isEmpty } from 'lodash';
import { curry, pipe } from 'rambda';
import getLoginRequest from './../services/prehandler/user/getLoginRequest';
import getOtpPayload from './../services/prehandler/user/getOtpPayload';
import registerConnector from './../services/connect/user/registerConnector';
import loginConnector from './../services/connect/user/loginConnector';
import guestLoginConnector from './../services/connect/user/guestLoginConnector';
import OtpConnect from './../services/connect/user/OtpConnect';
import forgetConnect from './../services/connect/user/forgetConnect';
import setRegisterData from './../services/decorator/user/setRegisterData';
import setLoginData from './../services/decorator/user/setLoginData';
import setOtpData from './../services/decorator/user/setOtpData';
import setGuestToken from './../services/decorator/user/setGuestToken';
import setForgetData from './../services/decorator/user/setForgetData';
const then = curry((f, p) => p.then(f));

const emitGlobalError = (payload) => {
    return {
        type: Constants.actions.ERROR_HANDLER.DISPLAY_ERROR_MESSAGE,
        payload: payload
    };
},

    removeGlobalError = (payload) => {
        return async (dispatch, getState) => {
            if (!isEmpty(getState().errorHandler.errors)) {
                return dispatch({
                    type: Constants.actions.ERROR_HANDLER.HIDE_ERROR_MESSAGE,
                    payload: payload
                });
            }

        }
    },

    registerUser = (data) => {
        return async (dispatch) => {
            dispatch({ type: Constants.actions.USER.POPUP_LOADER_REQUEST });
            const response = await pipe(registerConnector, then(setRegisterData))(data);
            const { type = '', payload = {} } = response;
            dispatch({
                type,
                payload
            });
        };
    },

    loginUser = (userInfo = {}) => {
        return async dispatch => {
            dispatch({ type: Constants.actions.USER.POPUP_LOADER_REQUEST });
            let response = await pipe(getLoginRequest, loginConnector, then(setLoginData))(userInfo);
            const { type = '', payload = {} } = response;
            dispatch({
                type,
                payload
            });
        };
    },

    forgetPass = (data) => {
        return async dispatch => {
            dispatch({ type: Constants.actions.USER.POPUP_LOADER_REQUEST });
            let response = await pipe(forgetConnect, then(setForgetData))(data);
            dispatch({
                type: response.type,
                payload: response.payload
            });

        };
    },

    getOtp = (otpJson = {}) => {
        return async dispatch => {
            dispatch({ type: Constants.actions.USER.POPUP_LOADER_REQUEST });
            const response = await pipe(getOtpPayload, OtpConnect, then(setOtpData))(otpJson);
            dispatch({
                type: response.type,
                payload: response.payload
            });

        };
    },

    loginGuestUser = () => {
        return async dispatch => {
            dispatch({ type: Constants.actions.USER.POPUP_LOADER_REQUEST });
            const response = await pipe(guestLoginConnector, then(setGuestToken))();
            dispatch({
                type: response.type,
                payload: response.payload
            });
        };
    };

export { emitGlobalError, removeGlobalError, registerUser, loginUser, forgetPass, getOtp, loginGuestUser };
